<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
<path d="M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z" />
</svg>
